import * as React from 'react';
import * as styles from './Cell.css';
import classNames from 'classnames';

interface CellOptions {
    id?: string;
    classes?: string | string[];
    style?: React.CSSProperties;
    children: any    
}

const Cell = (props: CellOptions) =>
    <span
        id={props.id}
        className={classNames(styles.cellMargin, props.classes)}
        style={props.style}
    >
        {props.children}
    </span>;

export default Cell;